export function hotjar() {
  const promise = new Promise((resolve, reject) => {
    const interval = setInterval(
      function () {
        if (window.hj) {
          resolve(window.hj);
          clearInterval(interval);
        }
      },
      200,
      50
    );
  });
  return promise;
}

export async function hotjarIdentify(
  studioURL: string,
  userId: string | number,
  type: string
) {
  const identity = {
    Studio: studioURL,
    Type: type,
  };
  const hj: any = await hotjar();
  hj('identify', userId, identity);
}
